// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"5b1d0bec","703":"25ee7ca5","787":"994511a4"}[chunkId] + ".chunk.js";
};